import { useEffect, useState } from "react";
import { api } from "@/lib/pos-api";

export default function ApiImage({ src, alt = "", ...props }) {
  const internal = typeof src === "string" && src.startsWith("/api/");
  const [blob, setBlob] = useState(null);
  useEffect(() => {
    if (!internal) return;
    const controller = new AbortController();
    let objectUrl;
    setBlob(null);
    // Fetch through the authenticated API client so master images use the selected tenant.
    api.get(src, { baseURL: window.location.origin, responseType: "blob", signal: controller.signal })
      .then(({ data }) => {
        if (controller.signal.aborted) return;
        objectUrl = URL.createObjectURL(data);
        setBlob({ src, url: objectUrl });
      }).catch(() => {});
    return () => { controller.abort(); if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src, internal]);
  return <img {...props} alt={alt} src={internal ? (blob?.src === src ? blob.url : undefined) : src} />;
}
